import { TH_GL_URL } from "./env";

/**
 * www.th.gl languages: every locale of the global UI dict (no aliases),
 * English unprefixed (www.th.gl/de/support-me). Every page exists in every
 * locale (apps/games-web/src/app/www/[locale]); pages not in
 * WWW_TRANSLATED_PATHS show their English content with a "not fully
 * translated" notice.
 */
export const WWW_LOCALES = [
  "en",
  "cs",
  "de",
  "es",
  "es-MX",
  "fr",
  "hu",
  "id",
  "it",
  "ja",
  "ko",
  "pl",
  "pt-BR",
  "ru",
  "th",
  "tr",
  "uk",
  "vi",
  "zh-CN",
  "zh-TW",
];

/** Pages whose content is translated (exact paths, English form). */
export const WWW_TRANSLATED_PATHS = [
  "/",
  "/support-me",
  "/companion-app",
  "/apps",
  "/support-me/account",
  "/previews",
  "/faq",
  "/stats",
  "/requests",
  "/suggestions-issues",
  "/developers",
  "/partner-program",
  "/advertise",
];
/**
 * Translated page families: every page below these (/apps/palia). /faq/<id>
 * counts although the answer itself is English content.
 */
const WWW_TRANSLATED_PREFIXES = [
  "/apps/",
  "/faq/",
  "/stats/",
  "/suggestions-issues/",
];

/** Whether `path` (English form, no locale prefix) is translated into `locale`. */
export function isWwwPageTranslated(path: string, locale: string): boolean {
  return (
    locale === "en" ||
    WWW_TRANSLATED_PATHS.includes(path) ||
    WWW_TRANSLATED_PREFIXES.some((prefix) => path.startsWith(prefix))
  );
}

/** Absolute www.th.gl URL for `path` in `locale` (www.th.gl/de/support-me). */
export function wwwUrl(path: string, locale?: string | null): string {
  const prefix =
    locale && locale !== "en" && WWW_LOCALES.includes(locale)
      ? `/${locale}`
      : "";
  return `${TH_GL_URL}${prefix}${path}`;
}
